import { render, staticRenderFns } from "./AIChatModule.vue?vue&type=template&id=7c7ba36b&scoped=true"
import script from "./AIChatModule.vue?vue&type=script&lang=js"
export * from "./AIChatModule.vue?vue&type=script&lang=js"
import style0 from "./AIChatModule.vue?vue&type=style&index=0&id=7c7ba36b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c7ba36b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/appdata/www/radzs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c7ba36b')) {
      api.createRecord('7c7ba36b', component.options)
    } else {
      api.reload('7c7ba36b', component.options)
    }
    module.hot.accept("./AIChatModule.vue?vue&type=template&id=7c7ba36b&scoped=true", function () {
      api.rerender('7c7ba36b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/frontend/components/modules/layouts-page/EditorControl/components/AIChat/AIChatModule.vue"
export default component.exports